<script lang="ts">
    import {createEventDispatcher, onMount} from 'svelte'
    import {get, writable} from 'svelte/store'
    import {onInput} from '../../../../lib/forms'
    import translate from '../../../../lib/translate'
    import {fade} from 'svelte/transition'
    import type {ILabel} from '../../../../types'
    
    import {NotificationType, PaymentType} from '../../types/Bids'
    import {CompleteDataResult, notificationsStore, sessionStore} from '../../stores'
    import label from './CompleteData.translation'
    
    let isProcessing = writable(true) // this form starts masked until fetchForm has completed
    let form = {
        invalidLabel: <ILabel|null>null,
        phone: {
            value: '',
            invalidLabel: <ILabel|null>null
        },
        paymentType: {
            value: PaymentType.creditCard
        },
        paymentTypes: [PaymentType.creditCard],
    }
    
    const fetchForm = async() => {
        try {
            let url = globalThis.config.baseUrl+'/bidagent/app/completeData/form_key/'+get(sessionStore).token
            
            const data = await fetch(url, { credentials: 'include' })
                .then(response => response.json())
                .finally(() => { isProcessing.set(false) })
            
            if(data.error) {
                if(data.error === 'invalid_token') {
                    window.document.location.reload()
                }
            } else {
                form.phone.value = data.phone
                form.paymentType.value = data.paymentType
                form.paymentTypes = data.paymentTypes
            }
        } catch(error) {
            console.error(error)
        }
    }
    const submitForm = async() => {
        
        form.invalidLabel = null
        form.phone.invalidLabel = form.phone.value === '' ? label.phoneInvalidEmpty : null
        if(form.phone.invalidLabel) {
            return
        }

        isProcessing.set(true)
        
        sessionStore.completeData(form.phone.value, form.paymentType.value)
            .then(result => {
                if(result === CompleteDataResult.success) {
                    closePanel()
                    notificationsStore.add({
                        type: NotificationType.confirmation,
                        title: translate(label.successNotificationTitle),
                        message: translate(label.successNotificationMessage),
                        durationMs: null,
                    })
                    return
                }
                if(result === CompleteDataResult.error) {
                    form.invalidLabel = label.serverError
                    return
                }
                if(result === CompleteDataResult.invalidPhoneEmpty) {
                    form.phone.invalidLabel = label.phoneInvalidEmpty
                    return
                }
                if(result === CompleteDataResult.invalidPhoneSyntax) {
                    form.phone.invalidLabel = label.phoneInvalidSyntax
                    return
                }
            })
            .finally(() => {
                isProcessing.set(false)
            })
    }

    const dispatch = createEventDispatcher()
    const closePanel = () => {
        dispatch('closePanel')
    }
    
    onMount(() => {
        fetchForm()
    })
</script>

<div class="auction-agent-display-activation auction-agent-form">
    <span class="close" on:click={closePanel}></span>
    
    <h3>{translate(label.activationTitle)}</h3>

    <form action="#" 
          class="dynamic-label agent-form"
          on:submit|preventDefault|stopPropagation={submitForm}
          novalidate>

        {#if form.invalidLabel}
            <div class="form-error-message">
                <p>{translate(form.invalidLabel)}</p>
            </div>
        {/if}

        <div class="input-box input-box-left">
            <input type="text"
                   placeholder=" "
                   name="agent-activation-phone" 
                   id="agent-activation-phone" 
                   bind:value="{form.phone.value}"
                   on:change={() => onInput(form.phone)}
                   on:keyup={() => onInput(form.phone)}>
            <label for="agent-activation-phone">{translate(label.telephone)}</label>

            {#if form.phone.invalidLabel}
                <p class="validation-advice" style="display:block">{translate(form.phone.invalidLabel)}</p>
                <div class="clear"></div>
            {/if}
        </div>
        
        <div class="input-box input-box-legend input-box-right">
            <p><small>{translate(label.telephoneHint)}</small></p>
        </div>
        
        <div class="input-box input-box-left">
            <div class="input-box-select select-box">
                <select name="agent-activation-payform"
                        id="agent-activation-payform"
                        bind:value={form.paymentType.value}>
                    {#each form.paymentTypes as paymentType}
                        <option value="{paymentType}">{translate(label.paymentType(paymentType))}</option>
                    {/each}
                </select>
                <label for="agent-activation-payform">{translate(label.paymentMethod)}</label>
            </div>
        </div>
        
        <div class="input-box input-box-legend input-box-right">
            <p><small>{translate(label.paymentMethodHint)}</small></p>
        </div>
        
        <button id="auctions-agent-activation-submit">{translate(label.save)}</button>
    </form>
    {#if $isProcessing}
        <div class="form-layover layover" out:fade></div>
    {/if}
</div>